module.exports = __webpack_public_path__ + "img/11.70c4ddf5.svg";